export const caracterizacaoEmpresasReducer = (previousState = {}) => {
  return previousState;
};
